import { render, staticRenderFns } from "./SearchMarketplace.vue?vue&type=template&id=795269c6"
import script from "./SearchMarketplace.vue?vue&type=script&lang=js"
export * from "./SearchMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports